// avatar.ts — gli avatar 3D tra cui ognuno sceglie la sua faccia (v019). Le immagini sono in web/public/avatar/
// (avatar-01.webp … avatar-NN.webp, più bot.webp e mistero.webp); qui solo quanti sono e come si chiamano i file.
// Aggiungere avatar: nuovi file con il numero successivo e AVATAR_NUMERO più alto (il database accetta fino a 999).

// v021: 50 avatar rifatti a 1254 px senza cerchio (il cerchio lo disegna l'app col colore primario); il 50 è il gatto.
export const AVATAR_NUMERO = 50;
/** Chi non ha ancora scelto vede questo (corona e occhi a cuore). */
export const AVATAR_PREDEFINITO = 1;

export function eAvatar(n: unknown): n is number {
  return typeof n === "number" && Number.isInteger(n) && n >= 1 && n <= AVATAR_NUMERO;
}

/** Indirizzo dell'immagine (relativo alla radice del sito o dell'app): 256 px, o 768 px con `grande`. */
export function fileAvatar(n: number | null | undefined, grande = false): string {
  const v = eAvatar(n) ? n : AVATAR_PREDEFINITO;
  return `/avatar/${grande ? "grande/" : ""}avatar-${String(v).padStart(2, "0")}.webp`;
}

export const FILE_AVATAR_BOT = "/avatar/bot.webp";
export const FILE_AVATAR_MISTERO = "/avatar/mistero.webp";
export const fileSpeciale = (nome: "bot" | "mistero", grande = false): string => `/avatar/${grande ? "grande/" : ""}${nome}.webp`;
